<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path fill="none" stroke="inherit" stroke-linecap="round" stroke-width="1.5" d="M7 3.67h10" />
      <path
        fill="none"
        stroke="inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m6.5 14.5 3-6.23v-4.6h5.01v4.6l3 6.23"
      />
      <path
        fill="none"
        stroke="inherit"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M5.25 20.2a1.36 1.36 0 0 1-.64-1.82L6.5 14.5s3.01 2.08 5.51 0 5.52 0 5.52 0l1.87 3.88a1.36 1.36 0 0 1-1.23 1.95H5.84c-.2 0-.4-.04-.6-.13Z"
      />
    </svg>
  </span>
</template>
